import React, { useEffect } from 'react';
import logo from '../../../assets/logo/LOGO_CAPBAY_VERTICAL_CROPPED.png';
import SignUpForm from './SignUpForm';

const SignUp = () => {
    useEffect(() => {
        sessionStorage.clear();
    }, []);

    return (
        <div className="account account--photo">
            <div className="account__wrapper">
                <div className="account__card">
                    <div>
                        <h3 className="account__title">
                            <span
                                className="account__logo account__logo-style"
                            >
                                <img
                                    src={logo}
                                    alt="logo"
                                    style={{
                                        width: '200px',
                                        marginLeft: 'auto',
                                        marginRight: 'auto',
                                        display: 'block',
                                    }}
                                />
                            </span>
                        </h3>
                    </div>
                    <SignUpForm />
                </div>
            </div>
        </div>
    );
};

export default SignUp;